/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Tab, { TabProps } from '@mui/material/Tab';

import DynaMedLogo from './DynaMed.svg';
import { DYNAMED_TAB_LABEL, DYNAMED_TAB_VALUE } from './dynamed';

const dynamedTabSx = {
  backgroundColor: '#5d84a0 !important',
  borderColor: '#063557 !important',
  '&:hover': {
    backgroundColor: '#4e7692 !important',
  },
  '&.Mui-selected': {
    backgroundColor: '#063557 !important',
    color: 'inherit',
  },
};

export function DynamedTab(props: TabProps) {
  return (
    <Tab
      label={<img src={DynaMedLogo} alt={DYNAMED_TAB_LABEL} style={{ display: 'block', height: 20 }} />}
      {...props}
      sx={dynamedTabSx}
      value={DYNAMED_TAB_VALUE}
    />
  );
}
